import React from 'react';

import Button from '@atlaskit/button';
import ErrorIcon from '@atlaskit/icon/glyph/error';

import {
  ButtonWrapperStyled,
  ContactStyled,
  ContainerStyled,
  ErrorStackStyled,
  HeaderWrapperStyled,
  TextStyled,
  TitleStyled,
} from './ErrorPage.styled';
import { sendErrorReport, splitToNewLines } from './ErrorPage.util';

const IS_PREMIUM_AND_SERVER =
  !plugin.isFree && plugin.runtimeEnvironment === 'server';

type Props = {
  message: string;
  error: Error;
  errorDetails?: any;
  stackTrace?: string;
};

export default function ErrorPage({
  message,
  error,
  errorDetails = {},
  stackTrace,
}: Props): JSX.Element {
  return (
    <ContainerStyled>
      <div>
        <HeaderWrapperStyled>
          <ErrorIcon
            label='Error icon'
            primaryColor='var(--ds-icon-danger, var(--ds-fb-icon-danger))'
            size='xlarge'
          />
          <TitleStyled>Whoops - this is embarrassing...</TitleStyled>
        </HeaderWrapperStyled>
        <TextStyled>
          Something apparently went wrong. Your error message is:
        </TextStyled>
        <ErrorStackStyled>
          <div>{message}</div>
          <div>{errorDetails?.reactObject}</div>
          <div>{splitToNewLines(stackTrace || error.stack)}</div>
        </ErrorStackStyled>
        <ContactStyled>
          If this error persists, please contact our{' '}
          <a
            href='https://soldevelo.atlassian.net/servicedesk/customer/portal/6'
            target='_blank'
            rel='noreferrer'
          >
            Support
          </a>{' '}
          for assistance.
        </ContactStyled>
        {IS_PREMIUM_AND_SERVER && (
          <ButtonWrapperStyled>
            <Button
              appearance='danger'
              onClick={() => sendErrorReport(error, message, errorDetails)}
            >
              Send report
            </Button>
          </ButtonWrapperStyled>
        )}
      </div>
    </ContainerStyled>
  );
}
